import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, SkipSelf, OnInit } from '@angular/core';

import { Product } from '../../../core/models/product'
import chaining from '../../../core/helpers/chaining';
import { Crumb } from '../../../core/models/crumb';
import { SKU } from '../../models/sku';
import { Assets } from '../../../core/models/product/assets';
import { PriceDetails } from '../../../core/models/product/price-details';
import { Price } from '../../../core/models/product/price';

@Component({
  selector: 'app-product-page',
  templateUrl: './product-page.component.html',
  styleUrls: ['./product-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductPageComponent {
  @Input() product: Product
  @Input() crumbs: Crumb[];
  @Input() showCrumbs: boolean;

  sizes: string[]
  
  zoomIsActive: boolean = false
  zoomSrc: string

  constructor() {

    // dummy  
    this.sizes = ["XXS", "XS", "S", "M"];
  }


  toggleZoom() {

    this.zoomSrc = "https://res.cloudinary.com/orderfield/image/upload/w_2000/v1570106126/harryshorse/products/26200511_zwart-1.jpg";

    this.zoomIsActive = !this.zoomIsActive;
  }

  getZoomUrl() {
    return "url('"+ this.zoomSrc +"')";
  }


}
